import React, { useEffect } from "react";
import InputContainer from "../../../citizen/AVPForms/layout/inputWrapper";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../../citizen/TCPForms/components/Button";
import { Col, Container, Row } from "react-bootstrap";
import SortingAlphabatically from "../../../citizen/AVPForms/reusableComponents/SortingAlphbatically";

const FilterForm = ({ onSubmit, userDetails, userType, location1, statusList }) => {
  const { handleSubmit, control, reset, watch, setValue } = useForm({
    defaultValues: {
      developmentAuthorityName: location1,
    },
  });
  const tenantId = Digit.ULBService.getStateId();
  const { data: { BPA: { Organizations: departmentListOptions } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [
    "Organizations",
  ]);
  console.log(departmentListOptions, location1, "departmentListOptions");
  function filterDepartmentsList(completeList) {
    console.log("completeListFromFunc", completeList);
    const filterCompList = completeList?.filter(
      (e) => !e?.Name?.includes("UP Housing and Development Board") && !e?.Name?.includes("Uttar Pradesh Online Building Plan Approval System")
    );
    const officeNames = filterCompList?.map((office) => ({ value: office.Name, label: office.Name }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  }
  useEffect(() => {
    if (departmentListOptions?.length && location1) {
      setValue("developmentAuthorityName", location1);
    }
  }, [departmentListOptions, location1, setValue]);

  const daList = departmentListOptions?.filter((item) => item.Type == "DA");
  const avpList = departmentListOptions?.filter((item) => item.Type == "AVP");

  const officesList = filterDepartmentsList(departmentListOptions);
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer"></div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                {/* <InputContainer
                  label="Application No"
                  control={control}
                  placeholder="Enter Application No"
                  name="applicationNo"
                  type="textInput"
                /> */}
                <InputContainer
                  label="Organization Name"
                  control={control}
                  placeholder="Select Organization"
                  name="developmentAuthorityName"
                  data={SortingAlphabatically(officesList)}
                  type={userType !== "Admin" ? "textInput" : "selectInput"}
                  disabled={userType !== "Admin"}
                />
              </Col>
              <Col>
                <InputContainer
                  label="Module Name"
                  control={control}
                  placeholder="Select Module Name"
                  data={[
                    { value: "Land Use", label: "Land Use" },
                    { value: "Map-Submission(200-500)", label: "Map Submission 200-50" },
                    { value: "Map-Submission(100-30)", label: "Map Submission 100-30" },
                    { value: "Plinth Submission", label: "Plinth Submission" },
                    { value: "Map Compounding", label: "Compounding Submission" },
                    { value: "Purchasable Map Submission", label: "Purchasable Map Submission" },
                    { value: "Approved Schemes", label: "Approved Schemes" },
                    { value: "Layout Approved by Authority", label: "Layout Approved by Authority" },
                  ]}
                  name="modulename"
                  type="selectInput"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputContainer label="From Date" control={control} placeholder="Select Date" name="createdFrom" type="datePicker" />
              </Col>
              <Col>
                <InputContainer label="To Date" control={control} placeholder="Select Date" name="createdTo" type="datePicker" disableFuture={true} />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputContainer label="Status" control={control} placeholder="Select Status" data={statusList} name="status" type="selectInput" />
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>
        <div className="footerContainer2">
          <div className="buttonWrapper" style={{ display: "flex", gap: "8px" }}>
            <ButtonWrapper variant="contained" color="success" size="medium" label="Search" type="submit" />
            <ButtonWrapper variant="contained" color="error" size="medium" label="Reset" onClick={reset} />
          </div>
        </div>
      </form>
    </section>
  );
};

export default FilterForm;
